import React, { useState } from "react";
import { format } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover/Popover";
import { Date as DateIcon } from "../Icon/Date";
import { Button } from "../Button/Button";
import { Calendar } from "../Calendar/Calendar";
import type { CalendarProps } from "../Calendar/Calendar";

import * as styles from "./DatePicker.module.scss";

type DatePickerProps = {
  buttonProps?: React.ComponentProps<typeof Button>;
  calendarProps?: CalendarProps;
  onSetDate?: (date: Date | undefined) => void;
  formatDate?: (date: Date) => string;
};

const DatePicker = ({
  buttonProps,
  calendarProps,
  onSetDate,
  formatDate = (d) => format(d, "PPP"),
}: DatePickerProps) => {
  const [date, setDate] = useState<Date>();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={(isOpen) => setIsOpen(isOpen)}>
      <PopoverTrigger asChild>
        <Button
          className={styles.button}
          variant={"secondary"}
          {...buttonProps}
        >
          <DateIcon />
          {date ? (
            formatDate(date)
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <Calendar
          {...calendarProps}
          mode="single"
          selected={date}
          onSelect={(date) => {
            setDate(date);
            onSetDate?.(date);
            setIsOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export { DatePicker };
export type { DatePickerProps };
